@if (file && (!isRaa || (isRaa && !file?.is_processing))) {
    @if ((file.file_type == 'image' || file.image) && !small) {
        <div class="text-center w-100 d-flex justify-content-center">
            <div class="w-content d-flex">
                <img [alt]="file.title" [src]="file.image" class="imageControl croppableMedia" fetchPriority="high"
                     loading="eager">
                @if (this.croppableFileType && this.croppable) {
                    <button (click)="this.initiateCrop.emit(file)" (keyup.enter)="this.initiateCrop.emit(file)"
                            aria-label="Crop image"
                            class="floatBtn" mat-mini-fab
                            matTooltip="Crop Image">
                        <mat-icon>crop</mat-icon>
                    </button>
                }
            </div>
        </div>
    }

    @if (((file.file_type == 'image' || file.image) && small)) {
        <img (click)="this.viewImage.emit()" (contextmenu)="false"
             (keydown.enter)="this.viewImage.emit()" (keydown.space)="$event.preventDefault(); this.viewImage.emit()"
             [alt]="file.title + 'image'" [attr.aria-label]="'View ' + file.title" [class.smallMedia]="small"
             [src]="file.thumbnail|| file.image"
             class="w-100 bg-primary"
             decoding="async" fetchpriority="low"
             loading="lazy"
             role="button" tabindex="0">
    }
    @if ((file.audio && file.audio.length > 0)) {
        <div [class.smallMedia]="small" class="audioControl">
            <app-audio-player (loading)="this.loading = $event"
                              (pauseSlideShow)="this.checkIfSmallBeforePause()"
                              (viewImage)="mediaClick()"
                              [file]="file.audio"
                              [mediaId]="file.id"
                              [small]="small"></app-audio-player>
        </div>
    }
    @if ((file.video && file.video.length > 0) && !small) {
        <video #video (click)="mediaClick($event)" (contextmenu)="false"
               (keydown.enter)="mediaClick($event)" (play)="this.checkUrl(file.video, 'video',  video)"
               [attr.aria-label]="small ? 'View ' + file.title : null"
               [attr.role]="small ? 'button' : null"
               [class.smallMedia]="small" [controls]="!small"
               [poster]="file.thumbnail || 'assets/images/video.png'"
               [preload]="small ? 'none' : 'metadata'"
               [src]="file.video" class="videoControl bg-primary"
               controls controlsList="nodownload noplaybackrate" tabindex="0">
            Your browser does not support the video tag.
        </video>
    } @else if ((file.video && file.video.length > 0) && small) {
        @if (file.thumbnail) {
            <!--if file.thumbnail then show a play button -->
            <button (click)="this.viewImage.emit()" [attr.aria-label]="'View ' + file.title"
                    class="mediaAction hoverImg" type="button">
                <div class="playBtn">
                    <img alt="" src="assets/images/videoAccessible.png">
                </div>
                <img (contextmenu)="false"
                     [alt]="file.title"
                     [class.smallMedia]="small" [src]="file.thumbnail"
                     class="w-100 bg-primary bgImage" fetchPriority="low">
            </button>
        } @else {
            <button (click)="this.viewImage.emit()" [attr.aria-label]="'View ' + file.title"
                    class="mediaAction" type="button">
                <img (contextmenu)="false"
                     [alt]="file.title"
                     [class.smallMedia]="small" class="w-100 bg-primary"
                     fetchPriority="low" src="assets/images/video.png">
            </button>
        }
    }
    @if (file.file_type == 'document' || file.document) {
        @if (this.displayableFileType && !documentLoadFailed) {
            <app-pdf-viewer (loadFailed)="documentLoadFailed = true"
                            (open)="mediaClick()"
                            (urlExpired)="refreshDocumentUrl()"
                            [class.smallMedia]="small"
                            [small]="small"
                            [src]="file.document"
                            [title]="file.title"
                            class="documentControl">
            </app-pdf-viewer>
        } @else {
            <button (click)="small ? this.viewImage.emit() :  this.download.emit()"
                    [attr.aria-label]="small ? 'View ' + file.title : 'Download ' + file.title"
                    [matTooltip]="!small ?  'Download Document' : null" class="mediaAction"
                    type="button">
                <img [alt]="file.title"
                     [class.smallMedia]="small"
                     [src]="'/assets/images/document.png'"
                     class="imageControl bg-primary aspectOne">
            </button>
        }
    }
    @if (loading) {
        <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
    }
} @else {
    <div (click)="mediaClick($event)" (keydown.enter)="mediaClick($event)"
         (keydown.space)="$event.preventDefault(); mediaClick($event)"
         [attr.aria-label]="small ? 'View media' : null"
         [attr.role]="small ? 'button' : null"
         [attr.tabindex]="small ? 0 : null"
         [class.aspectOne]="small"
         [matTooltip]="this.file?.is_processing? 'We\'re processing this memory. Please check back later' : ''"
         class="processingPlaceholder w-100 bg-primary py-10 d-flex justify-content-center align-items-center">
        <mat-progress-spinner [attr.aria-label]="this.file?.is_processing ? 'Processing memory' : 'Loading'"
                              class="scrollPassthrough"
                              color="accent"
                              mode="indeterminate"></mat-progress-spinner>
        @if (this.file?.is_processing) {
            <span class="cdk-visually-hidden" role="status">We're processing this memory. Please check back later</span>
        }
    </div>
}
